import { WithAccountId } from '@mews-commander/types';
import { useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { ProcessPaymentType } from '../../forms/ProcessPayment/ProcessPaymentType';
import { ProcessPaymentDialogButton } from '../../forms/ProcessPayment/ProcessPaymentDialogButton';

export const PreauthorizationsTableActionButtons = ({
    accountId,
    isCompany = false,
}: { isCompany: boolean } & WithAccountId) => {
    const isCompanyTerminalPaymentsEnabled = useFeatureFlag(FeatureFlag.companyTerminalPaymentsEnabled);
    return (
        <ProcessPaymentDialogButton
            accountId={accountId}
            allowedPaymentTypes={[
                ProcessPaymentType.GatewayCardPreauth,
                ProcessPaymentType.ExternalCardPreauth,
                ...(!isCompany || (isCompany && isCompanyTerminalPaymentsEnabled)
                    ? [ProcessPaymentType.MewsTerminalPreauth]
                    : []),
            ]}
            splitButtonTextKeys={{
                mainButton: TextKey.ProcessPaymentPanelTitleForPreauthorization,
                sideButton: TextKey.ProcessPaymentPanelTitleForAddExternalPreauthorization,
            }}
        />
    );
};
